import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import { useDTicketPriceConfig } from '@mopla/business-logic';
import { TMoplaColors } from '@mopla/mui';
import { IconMessage, InfoBaseIcon } from '@mopla/ui';
import { formatPrice } from '@mopla/utils';

interface ITemporalPriceInfoMessageProps {
	color?: TMoplaColors;
}

export const TemporalPriceInfoMessage: FC<ITemporalPriceInfoMessageProps> = ({
	color = 'neutral.80',
}) => {
	const { t } = useTranslation('dticket');
	const {
		messageVisibleFrom,
		messageVisibleUntil,
		priceChangeDate,
		dayBeforePriceChangeDate,
		oldPrice,
		newPrice,
	} = useDTicketPriceConfig();

	const now = dayjs();
	const isVisible =
		now.isAfter(dayjs(messageVisibleFrom)) &&
		now.isBefore(dayjs(messageVisibleUntil));

	if (!isVisible) return null;

	return (
		<IconMessage
			testId="TemporalPriceInfoMessage"
			icon={<InfoBaseIcon />}
			message={t('price_change_message', {
				oldPrice: formatPrice(oldPrice),
				newPrice: formatPrice(newPrice),
				oldPriceDate: dayjs(dayBeforePriceChangeDate).format('L'),
				newPriceDate: dayjs(priceChangeDate).format('L'),
			})}
			color={color}
		/>
	);
};
